import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@app/shared/header/header.component';

@Component({
  selector: 'if-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrl: './wrapper.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, RouterOutlet],
})
export class WrapperComponent {}
